import { createContext, useContext } from 'react';
import {
  CompanyInfo,
  UserInfo,
} from '~/store/apis/endpoints/userManagementApi/userManagement.api';

export interface IUserContext {
  user?: UserInfo;
  companies?: CompanyInfo[];
  hasUserInfoError?: boolean;
}

export const UserContext = createContext<IUserContext | undefined>(undefined);

export const useUser = (): IUserContext => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
